const BASE = (
  process.env.REACT_APP_EZTS_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_EZTS_API ||
  ''
).replace(/\/$/, '');

const joinUrl = (base, path) => {
  const b = String(base || '').replace(/\/+$/, '');
  const p = String(path || '').replace(/^\/+/, '');
  if (!b) return `/${p}`;
  return `${b}/${p}`;
};

const parseResponseBody = async (res) => {
  const contentType = res.headers?.get?.('content-type') || '';
  if (contentType.includes('application/json')) {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }
  try {
    return await res.text();
  } catch {
    return null;
  }
};

const httpJson = async (method, path, { body, headers } = {}) => {
  const url = joinUrl(BASE, path);
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
    body: body == null ? undefined : JSON.stringify(body),
  });

  const data = await parseResponseBody(res);
  if (!res.ok) {
    const err = new Error((data && data.message) || `Request failed (${res.status})`);
    err.response = { status: res.status, data };
    throw err;
  }
  // Return an axios-like response shape for existing callers.
  return { data, status: res.status, statusText: res.statusText, headers: {}, config: {} };
};

const isTruthyEnv = (v) => {
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === 'true' || s === '1' || s === 'yes' || s === 'y' || s === 'on';
};

export function isExpenseApiDisabled() {
  // CRA only injects REACT_APP_* vars, but we support both names.
  return isTruthyEnv(
    process.env.VITE_DISABLE_EXPENSE_API ||
    process.env.REACT_APP_VITE_DISABLE_EXPENSE_API
  );
}

export function isDevAuthBypassEnabled() {
  return isTruthyEnv(
    process.env.VITE_DEV_BYPASS_AUTH ||
    process.env.REACT_APP_VITE_DEV_BYPASS_AUTH
  );
}

const mockOk = (data = null) => ({
  data: { data },
  status: 200,
  statusText: 'OK',
  headers: {},
  config: {},
});

export function login({ email, password, username }) {
  if (!BASE) {
    return Promise.reject(
      new Error(
        'API base URL not configured (set REACT_APP_EZTS_API_BASE_URL or REACT_APP_API_BASE_URL or REACT_APP_EZTS_API in .env)'
      )
    );
  }
  const body = username ? { username, password } : { email, password };
  return httpJson('POST', 'auth/login', { body });
}

export function saveExpense({ token, payload }) {
  if (isExpenseApiDisabled()) return Promise.resolve(mockOk({ success: true }));
  if (!BASE) {
    return Promise.reject(
      new Error(
        'API base URL not configured (set REACT_APP_EZTS_API_BASE_URL or REACT_APP_API_BASE_URL or REACT_APP_EZTS_API in .env)'
      )
    );
  }
  return httpJson('POST', 'expense', {
    body: payload,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}

export async function getExpenseById({ id, token }) {
  if (isExpenseApiDisabled()) return mockOk(null);
  if (!BASE) {
    throw new Error(
      'API base URL not configured (set REACT_APP_EZTS_API_BASE_URL or REACT_APP_API_BASE_URL or REACT_APP_EZTS_API in .env)'
    );
  }
  if (!id) throw new Error('Missing expense id');
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  return httpJson('GET', `expense/${encodeURIComponent(String(id))}`, { headers });
}
